/// <amd-module name="Build/Common/Library/PipelineRunNameFormatter" />
import { format } from "VSS/Core/Util/String";

/**
 * Returns a string composed of the build number and the commit message,
 *  or just the build number if the appendCommitMessageToRunName parameter is set to false.
 * @param {string} buildNumber - The name of the completed build, also known as the run number.
 * @param {string} sourceVersionMessage - The comment of the commit or changeset.
 * @param {boolean} appendCommitMessageToRunName - Indicates whether the commit message should be appended to the build number. Defaults to true.
 * @returns {string}
 */
export function formatPipelineRunName(buildNumber: string, sourceVersionMessage: string, appendCommitMessageToRunName: boolean = true): string {
    let runName: string;
    if (appendCommitMessageToRunName && sourceVersionMessage !== "") {
        runName = format("#{0} • {1}", buildNumber, sourceVersionMessage);
    } else {
        runName = format("#{0}", buildNumber);
    }
    return runName;
}
